<template>
  <div class="p-12 space-y-8">
    <div class="text-center">
      <BaseButton tag="router-link" small primary :to="toPreview" target="_blank">
        Open in another tab
      </BaseButton>
    </div>
    <div class="max-w-4xl mx-auto">
      <Preview v-if="accOrder" :acc-order="accOrder" />
    </div>
  </div>
</template>

<script>
import Preview from 'Components/AccOrder/Preview.vue';

export default {
  components: {
    Preview,
  },
  props: {
    accOrderId: {
      type: String,
      required: true,
    },
  },
  computed: {
    accOrder() {
      return this.$store.state.entities.accOrders.byId[this.accOrderId];
    },
    toPreview() {
      return {
        name: 'accOrders.accOrderId.preview',
        params: {
          accOrderId: this.accOrderId,
        },
      };
    },
  },
  created() {
    this.fetchOrder();
  },
  methods: {
    async fetchOrder() {
      try {
        await this.$store.dispatch('ui/accOrders/read', {
          id: this.accOrderId,
          query: {
            include: 'products,lineItems,contact',
          },
        });
      } catch (error) {
        //
      }
    },
  },
};
</script>
